<template>
  <div class="organization-table-main">
    <div class="table-header">
      <div class="header-left">组织内账号</div>
      <div class="header-right">
        <el-button :disabled="current_channel === -1" type="text" @click="showModal('add')" v-if="isAdmin || (isAssociationUser && isOrganization)">添加账号</el-button>
      </div>
    </div>
    <div>
      <el-table :data="users_in_current_channel">
        <el-table-column
          prop="username"
          min-width="160"
          label="账号">
        </el-table-column>
        <el-table-column
          min-width="160"
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          min-width="160"
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          v-if="isAdmin || (isAssociationUser && isOrganization)"
          fixed="right"
          label="操作"
          min-width="160">
          <template slot-scope="scope">
            <el-button @click="showModal('edit', scope.row)" type="text" size="small">修改</el-button>
            <el-button type="text" size="small" @click="resetPasswordConfirm(scope.row)">重置密码</el-button>
            <el-button type="text" size="small" @click="deleteUserConfirm(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <PersonForm
      :type="modal_type"
      :item="modal_data"
      :isShow="is_show_modal"
      @DialogClose="DialogClose"
      :association="current_association"/>
  </div>
</template>
<script>
import PersonForm from './PersonForm.vue'
import { mapState } from 'vuex'
import { allUsers, resetPwdNormal, resetPwd, deleteNormal, deleteUser } from '@/api'

export default {
  components: {
    PersonForm
  },
  data () {
    return {
      is_show_modal: false,
      modal_type: 'add',
      modal_data: {}
    }
  },
  watch: {
    async current_channel (val) {
      if (val) {
        try {
          await allUsers(this, { channel: val })
        } catch (e) {
          console.log(e)
        }
      }
    }
  },
  computed: {
    isOrganization () {
      return Number.parseInt(this.current_channel) !== 0
    },
    isAssociationUser () {
      return this.$oneitfarm.hasRole('usermanagement.organization')
    },
    isAdmin () {
      return this.$oneitfarm.hasRole('usermanagement.association')
    },
    ...mapState({
      current_channel: 'current_channel',
      current_association: 'current_association',
      users_in_current_channel: 'users_in_current_channel'
    })
  },
  methods: {
    resetPasswordConfirm (person) {
      this.$confirm(`确定给  ${this.current_association.name}  的 ${person.name}（${person.username}）  密码重置为：${person.initPwd} ？`, '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.resetPassword(person.id)
      }).catch(() => {
      })
    },
    async resetPassword (id) {
      let response
      if (Number.parseInt(this.current_association.channel) === 0) {
        response = await resetPwd(this, id)
      } else {
        response = await resetPwdNormal(this, id)
      }
      if (response && Number.parseInt(response.ret) === 1) {
        this.$message.success('重置密码成功')
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    deleteUserConfirm (person) {
      this.$confirm(`此操作不可恢复 确定删除  ${this.current_association.name}  的 ${person.name}（${person.username}） ？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        message: this.$createElement('div', {
          style: {
            align: 'center'
          }
        }, [
          this.$createElement('p', {}, '此操作不可恢复'),
          this.$createElement('p', {}, `确定删除  ${this.current_association.name}  的 ${person.name}（${person.username}） ？`)
        ])
      }).then(() => {
        this.deleteUser(person.id, person.channel)
      }).catch(() => {
      })
    },
    async deleteUser (id, channel) {
      let response
      if (Number.parseInt(this.current_association.channel) === 0) {
        response = await deleteUser(this, id, channel)
      } else {
        response = await deleteNormal(this, id, channel)
      }
      if (response && Number.parseInt(response.ret) === 1) {
        this.$message.success('删除用户成功')
        allUsers(this, { channel })
      }
    },
    showModal (type, row = {}) { // type: add or edit
      this.is_show_modal = true
      this.modal_type = type
      this.modal_data = row
      console.log(this.modal_type, this.modal_data)
    },
    DialogClose () {
      this.is_show_modal = false
    }
  }
}
</script>
<style scoope>
.organization-table-main {
  display: flex;
  flex-direction: column;
  flex-basis: auto;
  margin-left: 40px;
  margin-top: 12px;
  margin-right: 120px;
}
.table-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header-left {
    font-family: 'PingFangSC-Regular', 'PingFang SC';
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: #6B6B6B;
}
.header-right{
    font-family: 'PingFangSC-Regular', 'PingFang SC';
    font-weight: 400;
    font-style: normal;
    color: #6699FF;
    text-align: right;
    margin-right: 20px;
}
</style>
